import ChatMessage, { ChatType, MessageRole } from './chat_message';

export default class ReportItem {
    constructor({ id, reportId, className, section, status, title, message }) {
        this.id = id;
        this.reportId = reportId;
        this.className = className;
        this.sec = section;
        this.status = status;
        this.title = title;
        this.message = message;
    }

    static fromJson(json, reportId) {
        if (!json || typeof json !== 'object') {
            throw new Error('Invalid JSON for ReportItem');
        }

        const message = new ChatMessage({
            id: json.id,
            reportId: reportId,
            content: json.content || '',
            role: MessageRole.ASSISTANT,
            type: ChatType.REPORT,
            isError: json.status === 'failed'
        });

        return new ReportItem({
            id: json.id,
            reportId: reportId,
            className: json.Class,
            section: json.sec,
            status: json.status,
            title: json.title,
            message: message
        });
    }
}
